import { render } from "./PhotoIcon.svg?vue&type=template&id=177873f5"
const script = {}
script.render = render

export default script